/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IServices } from '../services/ServicesTypes';
import {
    IMetadataReducerActionData,
    IReducerAction
} from '../store/types/ReducerTypes';
import { IMetadata } from '../store/types/MetadataTypes';

const MetadataActions = {
    METADATA_LOADING: 'METADATA_LOADING',
    METADATA_LOADED: 'METADATA_LOADED',
    METADATA_ERROR: 'METADATA_ERROR',
    METADATA_INVALID: 'METADATA_INVALID'
};

function publishMetadata(metadataObj: IMetadata): IReducerAction<IMetadataReducerActionData> {
    return {
        type: MetadataActions.METADATA_LOADED,
        data: { metadataObj }
    };
}

function publishMetadataError(errorDescriptor: any): IReducerAction<IMetadataReducerActionData> {
    return {
        type: MetadataActions.METADATA_ERROR,
        errorDescriptor
    };
}

function publishMetadataInvalid(errorDescriptor: any): IReducerAction<IMetadataReducerActionData> {
    return {
        type: MetadataActions.METADATA_INVALID,
        errorDescriptor
    };
}

function loadMetadata(server: string, uri: string) {
    return (dispatch: Function, getState: Function, services: IServices) => {
        services.metadataService.loadMetadata(server, uri)
            .then((response) => {
                dispatch(publishMetadata(response));
            })
            .fail((errorDescriptor: any) => {
                dispatch(publishMetadataError(errorDescriptor));
            });
    };
}

export {
    MetadataActions, loadMetadata, publishMetadata, publishMetadataError, publishMetadataInvalid
};
